import { Link } from "react-router-dom";
import {
  LISTING_CATEGORY_LABELS,
  ACCOUNT_PLATFORM_LABELS,
  type ListingResponse,
} from "@hybrid-escrow/shared";
import { Money } from "./Money";
import { StarRatingDisplay } from "./StarRating";
import { SellerBadges } from "./SellerBadges";
import { ListingCover } from "./ListingCover";

/** Shared listing-summary card used on the browse feed and a seller's storefront. Two separate
 *  inner links (listing detail vs. seller storefront) rather than one link wrapping the whole
 *  card — a `<Link>` inside another `<Link>` is invalid, unreliably-clickable HTML. */
export function ListingCard({ listing }: { listing: ListingResponse }) {
  return (
    <div className="listing-card">
      <Link to={`/listings/${listing.id}`} className="listing-card__link">
        <ListingCover listing={listing} className="listing-card__cover" />
        <span className="badge badge--neutral text-sm">
          {LISTING_CATEGORY_LABELS[listing.category]}
        </span>
        {listing.accountPlatform && (
          <span className="badge badge--info text-sm">
            {ACCOUNT_PLATFORM_LABELS[listing.accountPlatform]}
          </span>
        )}
        {listing.accountStatsFetchedAt && (
          <span className="badge badge--success text-sm" title="Public stats confirmed by the platform">
            ✓ Verified
          </span>
        )}
        {listing.domainName && (
          <span className="badge badge--info text-sm">{listing.domainName}</span>
        )}
        {listing.domainOwnershipVerifiedAt && (
          <span className="badge badge--success text-sm" title="Domain ownership confirmed via DNS">
            ✓ Verified
          </span>
        )}
        <h3>{listing.title}</h3>
      </Link>
      {listing.sellerUsername && (
        <Link to={`/sellers/${listing.sellerId}`} className="seller-link text-sm muted">
          by {listing.sellerUsername}
        </Link>
      )}
      <StarRatingDisplay rating={listing.sellerRating} size="sm" />
      <SellerBadges badges={listing.sellerBadges} />
      <Link to={`/listings/${listing.id}`} className="listing-card__link">
        <p className="desc">{listing.description}</p>
        <Money baseUnits={listing.priceBaseUnits} />
      </Link>
    </div>
  );
}
